module.exports = __webpack_public_path__ + "static/media/ic-search-light.9dfb2b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-search-light.svg
// module id = 658
// module chunks = 14